import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from "@tanstack/react-query";
import { Navigate, useParams } from "react-router-dom";
import { api } from "../../lib/api";
/** Skip the per-valuation landing page entirely — go straight to the
 *  latest version (or the current_version_id if set). The version
 *  detail page now hosts the Versions and Documents tabs that used to
 *  live here. */
export default function ValuationDetailPage() {
    const { valuationId = "" } = useParams();
    const val = useQuery({
        queryKey: ["valuation", valuationId],
        queryFn: () => api.get(`/valuations/${valuationId}`),
    });
    const versions = useQuery({
        queryKey: ["valuation", valuationId, "versions"],
        queryFn: () => api.get(`/valuations/${valuationId}/versions`),
    });
    if (val.isLoading || versions.isLoading) {
        return _jsx("p", { className: "text-sm text-ink-400", children: "Loading\u2026" });
    }
    if (!versions.data || versions.data.length === 0) {
        return (_jsx("p", { className: "text-sm text-amber-300", children: "This valuation has no versions yet \u2014 that shouldn't happen. Refresh, or contact support." }));
    }
    // Prefer the explicit `current_version_id`; otherwise fall back to the
    // highest version_number.
    const target = versions.data.find((v) => v.id === val.data?.current_version_id)
        ?? [...versions.data].sort((a, b) => b.version_number - a.version_number)[0];
    return _jsx(Navigate, { to: `/app/versions/${target.id}`, replace: true });
}
